<template>
  <div>
    <div v-if="availableDiscount" class="fixed top-0 w-full z-10">
      <Discount :discount="discount" />
    </div>
    <div :class="[availableDiscount ? 'pt-20 md:pt-16' : '', 'flex justify-between px-4 py-12 sm:p-12']">
      <div>
        <img :src="brokerLogoUrl" class="h-14" />
      </div>
      <img :src="logoUrl" class="h-12" />
    </div>
  </div>
</template>

<script>
import Discount from "@/components/subscription/Discount.vue";
import { isObjectValid } from "@estaly/ui";

export default {
  components: { Discount },

  props: ["discount", "brokerLogoUrl", "logoUrl"],

  computed: {
    availableDiscount() {
      return isObjectValid(this.discount?.title);
    },
  },
};
</script>
